// Meta Pixel utility — initializes the Facebook Pixel and exposes
// helpers to track standard events (PageView, AddToCart, etc.)

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

const PIXEL_ID = '1607641457021236'
let isInitialized = false

export function initMetaPixel() {
  if (typeof window === 'undefined' || isInitialized) return
  if (window.fbq) {
    isInitialized = true
    return
  }
  isInitialized = true

  // Initialize fbq queue
  const fbq: any = function () {
    // eslint-disable-next-line prefer-rest-params
    fbq.callMethod
      ? fbq.callMethod.apply(fbq, arguments as any)
      : fbq.queue.push(arguments)
  }
  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  // Inject the Meta Pixel script tag into <head>
  try {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const parent = document.head || document.body || document.documentElement
    if (parent) {
      parent.appendChild(script)
    }
  } catch (err) {
    // Fail silently — tracking should never break the page
    console.warn('Meta Pixel script injection failed:', err)
    return
  }

  try {
    window.fbq('init', PIXEL_ID)
  } catch (err) {
    console.warn('Meta Pixel init failed:', err)
  }
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', 'PageView')
    } catch (err) {
      console.warn('Meta Pixel PageView failed:', err)
    }
  }
}

export function trackAddToCart(data?: {
  value?: number
  currency?: string
  content_name?: string
  content_ids?: string[]
}) {
  if (typeof window !== 'undefined' && window.fbq) {
    try {
      window.fbq('track', 'AddToCart', data || {})
    } catch (err) {
      console.warn('Meta Pixel AddToCart failed:', err)
    }
  }
}
